/**
 * NAJAZD NA KARTĘ → ZNACZNIK NA MAPIE (pulpit, Piotr 7.10). Bez tej logiki przewijanie listy
 * przesuwało karty pod nieruchomym kursorem, `mouseenter` odpalał się na kolejnych kartach
 * i znaczniki migały jeden po drugim. Zasady:
 *  1. znacznik pokazuje się, gdy kursor ZATRZYMA się na karcie na `OPOZNIENIE_NAJAZDU_MS`;
 *     zjechanie z karty chowa go od razu;
 *  2. w trakcie przewijania i `CISZA_PO_PRZEWIJANIU_MS` po nim nic nie reaguje; działanie wznawia
 *     pierwszy PRAWDZIWY ruch myszy po tej ciszy. Prawdziwy = zmiana położenia kursora:
 *     przeglądarka po przewinięciu sama wysyła zdarzenia myszy w tym samym punkcie, a te nie
 *     mogą odblokować.
 * Czysta logika z wstrzykiwanym zegarem (testy: najazdKarty.test.ts); podpięcie w
 * `useNajazdKarty` (SearchPage).
 */
export const OPOZNIENIE_NAJAZDU_MS = 500;
export const CISZA_PO_PRZEWIJANIU_MS = 200;

export interface Zegar {
  setTimeout: (fn: () => void, ms: number) => unknown;
  clearTimeout: (id: unknown) => void;
  teraz: () => number;
}

const ZEGAR_PRZEGLADARKI: Zegar = {
  setTimeout: (fn, ms) => window.setTimeout(fn, ms),
  clearTimeout: (id) => window.clearTimeout(id as number),
  teraz: () => performance.now(),
};

export interface NajazdKarty {
  /** Kursor na karcie (wejście albo ruch po niej — wielokrotne wołanie nic nie psuje). */
  najazd: (id: string) => void;
  /** Kursor zjechał z karty. */
  zjazd: () => void;
  /** Przewinięcie listy albo kółko myszy. */
  przewiniecie: () => void;
  /** Ruch myszy gdziekolwiek, z położeniem kursora. */
  ruchMyszy: (x: number, y: number) => void;
  zniszcz: () => void;
}

export function utworzNajazdKarty(ustaw: (id: string | null) => void, zegar: Zegar = ZEGAR_PRZEGLADARKI): NajazdKarty {
  let aktywny: string | null = null;
  let czekajacy: string | null = null;
  let timer: unknown = null;
  let zablokowany = false;
  let ostatniePrzewiniecie = -Infinity;
  let pozycja: [number, number] | null = null;

  const anulujCzekanie = () => {
    if (timer != null) zegar.clearTimeout(timer);
    timer = null;
    czekajacy = null;
  };

  return {
    najazd(id) {
      if (zablokowany || id === aktywny || id === czekajacy) return;
      anulujCzekanie();
      czekajacy = id;
      timer = zegar.setTimeout(() => {
        timer = null;
        czekajacy = null;
        aktywny = id;
        ustaw(id);
      }, OPOZNIENIE_NAJAZDU_MS);
    },
    zjazd() {
      anulujCzekanie();
      if (aktywny != null) {
        aktywny = null;
        ustaw(null);
      }
    },
    przewiniecie() {
      zablokowany = true;
      ostatniePrzewiniecie = zegar.teraz();
      anulujCzekanie();
    },
    ruchMyszy(x, y) {
      const ruszyl = pozycja == null || pozycja[0] !== x || pozycja[1] !== y;
      pozycja = [x, y];
      if (zablokowany && ruszyl && zegar.teraz() - ostatniePrzewiniecie >= CISZA_PO_PRZEWIJANIU_MS) zablokowany = false;
    },
    zniszcz() {
      anulujCzekanie();
    },
  };
}
